import styled from 'styled-components';
import { Body2Alt } from '@prezi/bento';
import { EIGHT, SUB_HEADING_Z } from '../../const';
const SectionHeader = styled(Body2Alt).withConfig({
  displayName: "SectionHeader",
  componentId: "sc-1swvl82-0"
})(["position:sticky;top:", "px;z-index:", ";padding:", "px;background:", ";"], EIGHT * 6, SUB_HEADING_Z, EIGHT, ({
  theme
}) => theme.bento.colors.background.main);
export const SimpleSectionHeader = styled(SectionHeader).withConfig({
  displayName: "SectionHeader__SimpleSectionHeader",
  componentId: "sc-1swvl82-1"
})(["padding-top:0;padding-inline-start:0;"]);
export default SectionHeader;